import React, { useEffect } from 'react'
import { Switch, Route } from 'react-router-dom'

import './styles/index.scss'

// Import emergency cleanup utility for development
import './utils/emergencyCleanup'

import LoaderComponent from './components/CommonComponents/LoaderComponent'

import useAuth from './auth/useAuth'
import OnboardingGate from './auth/OnboardingGate'

import MainRouter from './MainRouter'
import Auth from './pages/Auth'
import Login from './pages/Login'
import Logout from './pages/Logout'
import Signup from './pages/Signup'
import SignupComplete from './pages/Signup/SignupComplete'
import SignupAudit from './pages/Signup/SignupAudit'
import SignupAuditComplete from './pages/Signup/SignupAuditComplete'
import SignupSpecial from './pages/Signup/SignupSpecial'
import SignupSpecialComplete from './pages/Signup/SignupSpecialComplete'
import Impersonate from './pages/Impersonate'

import { C6_NAVBAR_SCRIPT } from './config/api'

const App = () => {
  const { isLoading, isAuthenticated, getAccessTokenSilently } = useAuth()

  useEffect(() => {
    // An empty C6_NAVBAR_SCRIPT turns the navbar off (e.g. locally, when navbar-api rejects the token).
    if (!isAuthenticated || !C6_NAVBAR_SCRIPT) {
      return
    }

    // Inject Carbon6 navbar script.
    let navbarHolder = document.getElementById('c6_navbar')
    if (!navbarHolder) {
      navbarHolder = document.createElement('div')
      navbarHolder.setAttribute('id', 'c6_navbar')
      document.body.prepend(navbarHolder)
    }

    let navbarScript = document.getElementById('c6-navbar-script')
    if (!navbarScript) {
      const script = document.createElement('script')
      script.setAttribute('id', 'c6-navbar-script')
      script.setAttribute('type', 'text/javascript')
      script.src = C6_NAVBAR_SCRIPT
      script.onload = function () {
        window.globalThis.c6Navbar.updateProps({
          currentPage: 'PPC_ENTOURAGE',
          // Our sign-out page clears the local session before the Hub logout.
          signOutUrl: `${window.location.origin}/logout`,
          getAccessToken: () => getAccessTokenSilently(),
        })
      }
      document.body.appendChild(script)
    }
  }, [isAuthenticated]) // eslint-disable-line

  if (isLoading) {
    return <LoaderComponent />
  }

  return (
    <OnboardingGate>
      <Switch>
        <Route
          path='/login'
          component={Login}
        />
        <Route
          path='/auth'
          component={Auth}
        />
        <Route
          path='/logout'
          component={Logout}
        />
        <Route
          path='/signup'
          component={Signup}
        />
        <Route
          path='/signup-complete'
          component={SignupComplete}
        />
        <Route
          path='/v2/signup-complete'
          component={SignupComplete}
        />
        <Route
          path='/signup-audit'
          component={SignupAudit}
        />
        <Route
          path='/signup-audit-complete'
          component={SignupAuditComplete}
        />
        <Route
          path='/amz-webinar-signup'
          component={SignupSpecial}
        />
        <Route
          path='/amz-webinar-signup-complete'
          component={SignupSpecialComplete}
        />
        <Route
          path='/28fc836a114602bb2e6ae8f3c2f71de4'
          component={Impersonate}
        />
        <Route path="/" component={MainRouter} />
      </Switch>
    </OnboardingGate>
  )
}

export default App
